import { PropTypes } from 'prop-types';
import React from 'react';
import DropdownMenu from './dropdown-menu';
import Config from '../config';

import { LARGE } from '../../breakpoint-controller';

const FilterBar = ({
    filterOptions,
    filter,
    isLoading,
    onInputChange,
    clearFilter,
    onClickDropdownOption,
    searchPlaceholder = Config.searchPlaceholder
}) => {
    const filterDropdowns = filterOptions.map(fo => (
        <DropdownMenu
            {...fo}
            key={fo.name}
            activeOptions={filter[fo.name] ? filter[fo.name] : []}
            onClickOption={onClickDropdownOption}
        />
    ));

    let classList = ['filter-bar'];
    if (isLoading) {
        classList.push('loading');
    }

    return (
        <div className={classList.join(' ')}>
            <div className="filter-bar-wrapper">
                <button className="mobile-filter-toggle">
                    <i class="icon icon-filter" />
                </button>

                <div className="filter-dropdown-items">
                    <label className="filter-dropdowns-label">Filter By</label>
                    {filterDropdowns}
                </div>

                <div className="input-wrapper">
                    <input
                        type="search"
                        placeholder={searchPlaceholder}
                        onChange={onInputChange}
                    />
                    <i className="icon icon-search" data-grunticon-embed />
                </div>
            </div>
        </div>
    );
};

function onClickMobileFilterBarToggle() {
    jQuery('.filter-bar .dropdown-menu').slideToggle();
}

function onClickDropdownLabel(e) {
    if (window.innerWidth < LARGE) {
        let clicked = jQuery(e.currentTarget);
        let options = clicked.closest('.dropdown-menu').find('.options');

        options.slideToggle();
    }
}

function onDocumentReady() {
    let filterBar = jQuery('.filter-bar');

    if (filterBar) {
        filterBar
            .on('click', '.dropdown-label', onClickDropdownLabel)
            .on('click', '.mobile-filter-toggle', onClickMobileFilterBarToggle);
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);

FilterBar.propTypes = {
    filterOptions: PropTypes.array,
    filter: PropTypes.object,
    isLoading: PropTypes.bool,
    onInputChange: PropTypes.func,
    clearFilter: PropTypes.func,
    onClickDropdownOption: PropTypes.func,
    searchPlaceholder: PropTypes.string
};

export default FilterBar;
